import HttpClient from './httpClient'

class ApiClient {

    constructor(token) {
      let baseUrl = process.env.REACT_APP_BASE_URL
      this.httpClient = new HttpClient(baseUrl)
      this.config = {
        headers: {
            'Authorization': 'Bearer ' + token,
        }
      }
    }

    getSchoolsUnpaginated() {
        return this.httpClient.get('/schools/mobile', this.config)
    }

    getCampuses(querySring) {
        return this.httpClient.get(`/campuses${querySring}`, this.config)
    }

    getClassrooms(querySring) {
        return this.httpClient.get(`/classrooms${querySring}`, this.config)
    }

    getGrades(querySring) {
        return this.httpClient.get(`/grades${querySring}`, this.config)
    }

    getTeachers(querySring) {
        return this.httpClient.get(`/teachers${querySring}`, this.config)
    }
    
    updateStudent(id, data) {
        return this.httpClient.put(`/students/${id}`, data, this.config)
    }

  }
  
  export default ApiClient